module.exports = ".form-check-personalized {\n  position: relative;\n  display: initial;\n  padding-left: 1.25rem; }\n\n.form-personalized {\n  display: initial; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/process-automation/flow-navigator/flow-navigator.component.scss
// module id = ./src/app/administration/process-automation/flow-navigator/flow-navigator.component.scss
// module chunks = main